module.exports = __webpack_public_path__ + "img/printer_icon.1838e157.png";